import './App.css';
import ImageBanner from './components/Banner/ImageBanner';
import ImageList from './components/List/ImageList';

function App() {


  return (
      <div>
        <ImageBanner />
        <ImageList />
      </div>

    
  );
}

export default App;
